import { useState } from 'react';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { Image } from 'react-bootstrap';

type Props = {
  imageList?: (string | undefined)[] | null;
};

const ImageGallery = ({ imageList }: Props) => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const list = imageList ?? [];

  const handleImageClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handleNext = () => {
    if (currentIndex == null || list.length === 0) return;
    setCurrentIndex((currentIndex + 1) % list.length);
  };

  const handlePrev = () => {
    if (currentIndex == null || list.length === 0) return;
    setCurrentIndex((currentIndex - 1 + list.length) % list.length);
  };
  return (
    <>
      {list.map((src, index) => (
        <Image
          key={index}
          src={src}
          thumbnail
          onClick={() => handleImageClick(index)}
          style={{
            maxWidth: '210px',
            maxHeight: '180px'
          }}
          className="border cursor-pointer"
        />
      ))}
      {typeof currentIndex !== 'object' && currentIndex != null ? (
        <Lightbox
          onCloseRequest={() => setCurrentIndex(null)}
          mainSrc={list[currentIndex] ?? ''}
          nextSrc={list[(currentIndex + 1) % list.length]}
          prevSrc={list[(currentIndex - 1 + list.length) % list.length]}
          onMovePrevRequest={handlePrev}
          reactModalStyle={{ overlay: { zIndex: 999999 } }}
          onMoveNextRequest={handleNext}
          onImageLoad={() => {
            window.dispatchEvent(new Event('resize'));
          }}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ImageGallery;
